import { cx } from '@twind/core';
import { Subheading } from 'app/components/Typography';
import { useTranslation } from 'react-i18next';
import Typing from 'app/components/Typing';
import { useCallback } from 'react';

import { MessageReadMarker } from './MessageReadMarker';

type Props = {
  index: number;
  className?: string;
};

const ConnectingMessage = ({ index, className }: Props) => {
  const { t } = useTranslation();

  const ref = useCallback((el: HTMLDivElement) => {
    if (el) {
      el.scrollIntoView({ block: 'end' });
    }
  }, []);

  return (
    <div>
      <div
        ref={ref}
        className={cx('flex gap-3 items-center', className)}
      >
        <div className="flex items-center w-[24px] h-[24px] object-cover rounded-full">
          <Typing
            width={24}
            height={24}
          />
        </div>
        <Subheading className="font-semibold">{t('connecting_message')}</Subheading>
      </div>
      <MessageReadMarker index={index} />
    </div>
  );
};

export default ConnectingMessage;
